/**
 * Deal Hub outcome queue — "N properties need an update".
 *
 * Under `_auth-minimal` deliberately: these are full-page interstitials that
 * replace the Offers page entirely, with nothing visible behind them, so the
 * navbar-bearing shell would contradict the design. The only way out is
 * "Skip to dashboard" in the queue header.
 */

import { DealHubOutcomeQueue } from '@/features/properties/components/DealHubOutcomeQueue'

export const Route = createFileRoute({
  component: DealHubOutcomeQueue,
})
